import { runStatusLabel, stageStatusLabel } from './marketAnalysis.js'

export function stageActivityLabel(stage) {
  if (stage?.error_code === 'RESEARCH_PROFILE_INVALID') return '需要修正企业资料'
  if (stage?.status !== 'waiting_retry') return stageStatusLabel(stage?.status)
  if (stage.error_code === 'ANALYSIS_SERVICE_WAIT') return '等待平台处理'
  if (stage.error_code === 'RESEARCH_EVIDENCE_GAP') return '等待补充资料'
  return stage.next_attempt_at ? '等待下次尝试' : '等待恢复安排'
}
export function analysisActivityLabel(run) {
  if (!run) return '尚未开始分析'
  if (run.failure_code === 'RESEARCH_PROFILE_INVALID' || run.stages?.some(stage => stage.error_code === 'RESEARCH_PROFILE_INVALID')) return '需要修正企业资料'
  if (run.status === 'waiting_retry') {
    return stageActivityLabel(run.stages?.find(stage => stage.status === 'waiting_retry') || { status: 'waiting_retry' })
  }
  return runStatusLabel(run.status)
}
export function brainTodos(data, known) {
  const items = []
  if (known('profile') && !data.profile?.current) items.push({ title: '保存正式企业资料', to: 'company/basic' })
  const invalid = data.run?.stages?.find(stage => stage.error_code === 'RESEARCH_PROFILE_INVALID')
  const waiting = invalid || data.run?.stages?.find(stage => stage.status === 'waiting_retry')
  if (known('run') && waiting) items.push({ title: stageActivityLabel(waiting), body: waiting.error_message, to: invalid ? 'company/basic' : 'company/market', hash: invalid ? '#competitorUrls' : '' })
  if (known('policy') && Number.isFinite(data.policy?.material_readiness?.ready_image_count) && data.policy.material_readiness.ready_image_count < 2) {
    items.push({ title: `补充可授权图片：还需 ${2 - data.policy.material_readiness.ready_image_count} 张`, body: '当前内容准备至少需要 2 张可用图片。', to: 'materials' })
  }
  if (known('assignments') && !data.assignments?.some(item => item.status === 'active')) items.push({ title: '连接用户手机', body: '通过人设二维码绑定 AI 营销助手。', to: 'personas' })
  if (known('policy') && data.policy?.blocker?.message) items.push({ title: '处理任务执行条件', body: data.policy.blocker.message, to: 'daily-tasks' })
  return items.slice(0, 3)
}
export function todayMetrics(today, date) {
  if (today?.scope !== 'day' || today?.summary_complete !== true || today.local_date !== date) return null
  const m = today.metrics || {}
  return [
    ['任务已创建', m.covered_apps], ['内容已就绪', m.receivable_tasks],
    ['待手机接收', Math.max(0, m.receivable_tasks - m.received_tasks)],
    ['手机已收到', m.received_tasks], ['图文已生成', m.png_ready_tasks], ['发布已核验', m.verified_tasks],
  ].map(([label, value]) => ({ label, value: Number.isFinite(value) ? value : '待确认' }))
}
export function personaSummary(batch, progress) {
  if (progress?.active) return `正在生成 ${progress.prepared_count ?? 0}/${progress.total_count ?? 20}`
  if (['failed', 'needs_attention', 'cancelled'].includes(progress?.status)) return '生成已暂存，查看处理方式'
  if (batch) return `已启用 ${batch.generated_count ?? 0}/20`
  return progress?.status === 'waiting_approval' ? '等待确认生成' : '尚未生成'
}
